import fs from 'fs';
import fse from 'fs-extra';
import { Common } from '../common';

export class FileUpdater {
    public copyNewFiles(audit: boolean, internal: boolean, updateSource: string[], library: boolean, internalOverride: boolean): void {
        if (audit) {
            return;
        }

        const ignoresPath = Common.cliRootPath + 'templates\\ignores';
        const internalPath = Common.cliRootPath + 'templates\\internal';
        const libraryPath = Common.cliRootPath + 'templates\\library';
        const gulpPath = Common.moduleTemplatePath + 'gulpfile.ts';
        const upgradedTemplatePath = Common.cliRootPath + 'templates\\wac-template';

        fse.copyFileSync(ignoresPath + '\\git.txt', '.\\.gitignore');
        fse.copyFileSync(ignoresPath + '\\npm.txt', '.\\.npmignore');
        fse.copyFileSync(ignoresPath + '\\browserslistrc.txt', '.\\.browserslistrc');
        fse.copyFileSync((internal ? internalPath : upgradedTemplatePath) + '\\.eslintrc.json', '.\\.eslintrc.json');
        fse.copySync(gulpPath + '\\common', '.\\gulpfile.ts\\common');
        fse.copyFileSync(gulpPath + '\\index.ts', '.\\gulpfile.ts\\index.ts');
        fse.copyFileSync(upgradedTemplatePath + '\\tsconfig.base.json', '.\\tsconfig.base.json');
        fse.copyFileSync(upgradedTemplatePath + '\\tsconfig.json', '.\\tsconfig.json');
        fse.copyFileSync((library ? libraryPath : upgradedTemplatePath) + '\\angular.json', '.\\angular.json');
        fse.copyFileSync(upgradedTemplatePath + '\\src\\tsconfig.app.json', '.\\src\\tsconfig.app.json');
        fse.copyFileSync(upgradedTemplatePath + '\\src\\tsconfig.spec.json', '.\\src\\tsconfig.spec.json');
        fse.copyFileSync(upgradedTemplatePath + '\\src\\polyfills.ts', '.\\src\\polyfills.ts');
        fse.copyFileSync(upgradedTemplatePath + '\\src\\karma.conf.js', '.\\src\\karma.conf.js');
        fse.copyFileSync(upgradedTemplatePath + '\\src\\test.ts', '.\\src\\test.ts');

        this.updateGulpConfigFile('.\\gulpfile.ts\\config-data.ts', library);

        if (internal || internalOverride) {
            fse.copyFileSync(internalPath + '\\version.ts', '.\\src\\version.ts');
            fse.copySync(internalPath + '\\azuredevops', '.\\.azuredevops');
            fse.copySync(Common.moduleTemplatePath + '\\build', '.\\build');
            this.updateLocalizationPipeline('.\\loc\\locConfig.xml', '.\\build\\pipelines\\localization.yml', updateSource);
            this.updateMainFile(internalPath + '\\main.ts', '.\\src\\main.ts');
            this.updateVersionJson(internalPath + '\\version.json', '.\\version.json');
        }

        if (library) {
            fse.copyFileSync(libraryPath + '\\tsconfig.lib.json', '.\\src\\tsconfig.lib.json');
            fse.copyFileSync(libraryPath + '\\tsconfig.lib.prod.json', '.\\src\\tsconfig.lib.prod.json');
            fse.copyFileSync(libraryPath + '\\ng-package.json', '.\\src\\ng-package.json');
            fse.copyFileSync(libraryPath + '\\package.json', '.\\src\\package.json');
            fse.copyFileSync(libraryPath + '\\public_api.ts', '.\\src\\public_api.ts');

            if (!fse.existsSync('.\\src\\app\\index.ts')) {
                fse.copyFileSync(libraryPath + '\\index.ts', '.\\src\\app\\index.ts');
            }
        }

        if (fse.existsSync('.\\tsconfig.inline.json')) {
            fs.unlinkSync('.\\tsconfig.inline.json');
        }

        if (fse.existsSync('.\\index.js')) {
            fs.unlinkSync('.\\index.js');
        }

        if (fse.existsSync('.\\index.d.ts')) {
            fs.unlinkSync('.\\index.d.ts');
        }

        console.log('All new config and json files have been transferred.');
    }

    private updateGulpConfigFile(filePath: string, library: boolean): void {
        let fileData = Common.readFileData(filePath);

        fileData = fileData.replace('\nfunction gulpConfig():', '\nexport function gulpConfig():');
        fileData = fileData.replace('\nexports.gulpConfig = gulpConfig;', '');

        if (library) {
            if (fileData.search('build: {') === -1) {
                const captureInsertLocation = /(?<=powershell: {[\s\S]+\s+)}/;
                fileData = Common.replaceInString(fileData, captureInsertLocation, `},\n${' '.repeat(8)}build: {\n${' '.repeat(12)}library: true\n${' '.repeat(8)}}`);
            } else if (fileData.search('library: ') === -1) {
                const captureInsertLocation = /(?<=build: ){/;
                fileData = Common.replaceInString(fileData, captureInsertLocation, `{\n${' '.repeat(12)}library: true,`);
            } else {
                fileData = fileData.replace('library: false', 'library: true');
            }
        }

        fse.writeFileSync(filePath, fileData);
    }

    private updateLocalizationPipeline(locFilePath: string, pipelineFilePath: string, updateSource: string[]): void {
        const captureTFSSourceDirectory = /(?<=path=")%.+%\\(?=.*"\s)/;
        const captureModuleId = /(?<=name=").+(?=.*"\s)/;

        if (!fse.existsSync(locFilePath)) {
            const message = `Path ${locFilePath} does not exist. Please verify this file exists.`;
            console.log(message);
            updateSource.push(message + '\n');
            return;
        }

        let locFileData = Common.readFileData(locFilePath);
        locFileData = Common.replaceInString(locFileData, captureTFSSourceDirectory, '');
        fse.writeFileSync(locFilePath, locFileData);

        const moduleId = locFileData.match(captureModuleId);
        if (!moduleId || moduleId.length === 0) {
            const message = `Couldn't retrieve localization module ID from ${locFilePath}, localization ID will need to be updated manually.`;
            console.log(message);
            updateSource.push(message + '\n');
            return;
        }

        let pipelineFileData = Common.readFileData(pipelineFilePath);
        pipelineFileData = pipelineFileData.replace('${module-id}', moduleId[0]);
        fse.writeFileSync(pipelineFilePath, pipelineFileData);
    }

    private updateMainFile(internalFilePath: string, targetFilePath: string) {
        let fileData: string = Common.readFileData(targetFilePath);
        const captureName = /(?<=name: ').*(?=')/;
        const name = fileData.match(captureName)[0];

        fse.copyFileSync(internalFilePath, targetFilePath);
        fileData = Common.readFileData(targetFilePath);
        fileData = fileData.replace(`{!company-name}.{!product-name}`, name);

        fse.writeFileSync(targetFilePath, fileData);
    }

    private updateVersionJson(internalFilePath: string, targetFilePath: string) {
        const newVersion = Common.readFileJSON(internalFilePath).version;

        const versionData = Common.readFileJSON(targetFilePath);
        versionData.version = newVersion;

        fse.writeJSONSync(targetFilePath, versionData, { spaces: 2 });
    }
}
